import {
  JobStatusFilter,
  type JobConnection,
  type Job as GraphqlJob,
} from 'src/graphql/__generated__';
import type { Job } from 'src/types';
import { mapNullOrEmptyToUndefined } from 'src/utils/mapNullOrEmptyToUndefined';

import type { QueryParamTab } from '../useQueryParam';

export const defaultStatuses: JobStatusFilter[] = [
  JobStatusFilter.ACTIVE,
  JobStatusFilter.BLOCKED,
  JobStatusFilter.PENDING_ACCOUNT_APPROVAL,
  JobStatusFilter.SUSPENDED,
];

export const mapTabToStatusFilters = (
  tab?: QueryParamTab,
): JobStatusFilter[] => {
  const mapper: Record<QueryParamTab, JobStatusFilter[]> = {
    open: defaultStatuses,
    expired: [JobStatusFilter.EXPIRED],
    draft: [],
  };

  if (!tab) {
    return defaultStatuses;
  }

  return mapper[tab];
};

const mapJob = (job: GraphqlJob): Job => ({
  jobId: job.id,
  advertiserReference: mapNullOrEmptyToUndefined(job.advertiserJobReference),
  agencyReference: undefined,
  createdBy: job.owner?.fullName ?? undefined,
  createdDate: job.createdDate,
  listingDate: job.listingDate ?? undefined,
  daysRemaining: job.daysRemaining ?? undefined,
  postType: job.postType,
  title: job.title,
  status: job.status,
  location: job.locations[0],
  performanceRating: job.performanceRating ?? undefined,
  numberOfCandidates: job.candidatesCount ?? 0,
  numberOfNewCandidates: job.newCandidatesCount ?? 0,
  canBeRefreshed: job.canBeRefreshed,
  canBeUpgraded: job.canBeUpgraded,
});

export const mapJobs = (jobConnection?: JobConnection): Job[] => {
  const jobNodes = (jobConnection?.edges ?? [])
    .map((jobEdge) => jobEdge.node)
    .filter((job): job is GraphqlJob => job.__typename === 'Job');

  return jobNodes?.map(mapJob);
};
